import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { RouteUiDataService } from '../../route-ui-data';

/**
 * Shell page heading. Reads heading + lead + visuallyHidden from the
 * active route's `data.heading` via RouteUiDataService. Dynamic blog
 * routes call `RouteUiDataService.setHeadingOverride()` to publish a
 * per-slug heading; the service's `heading` computed prefers the
 * override over the static route value.
 *
 * Renders nothing when no heading is registered (empty title string).
 */
@Component({
  selector: 'app-page-heading',
  imports: [],
  templateUrl: './page-heading.component.html',
  styleUrl: './page-heading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeadingComponent {
  private readonly routeUiData = inject(RouteUiDataService);

  // Provide an EMPTY default so the template's @if (heading().title)
  // check naturally suppresses rendering on routes without a heading.
  protected readonly heading = computed(
    () => this.routeUiData.heading() ?? { title: '', visuallyHidden: false },
  );
}
